// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","363":"a4188c6a","396":"5625bbf6","455":"a687ac16","602":"ce4082c2","977":"670b9fab"}[chunkId] + ".chunk.js";
};